import { ModelValue } from '../types';

export const stringFromModelValue = (value: ModelValue | undefined): string | undefined =>
	Array.isArray(value) ? (value[0] instanceof File ? value[0].name : value[0]) : value;

export const fileFromModelValue = (value: ModelValue | undefined): File | undefined =>
	Array.isArray(value) ? (value[0] instanceof File ? value[0] : undefined) : undefined;

export const intFromModelValue = (value: ModelValue | undefined): number => {
	const stringValue = stringFromModelValue(value);
	if (!stringValue) {
		return NaN;
	}
	return parseInt(stringValue, 10);
};

export const floatFromModelValue = (value: ModelValue | undefined): number => {
	const stringValue = stringFromModelValue(value);
	if (!stringValue) {
		return NaN;
	}
	return parseFloat(stringValue);
};

export const booleanFromCheckbox = (checkboxValue: ModelValue | undefined, singleValue: string): boolean => {
	if (!checkboxValue || !Array.isArray(checkboxValue)) {
		return false;
	}
	if (checkboxValue[0] instanceof File) {
		return false;
	}
	return (checkboxValue as string[]).includes(singleValue);
};
